import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'

export const ResultsFoundChart: React.FunctionComponent = (props) => {

    return (
        <BPMChart {...props} title='Results Found' type='pie'
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('search/resultsFound', options, signal)
            }} additionalParams={{ limit: 120 }}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: 'Found',
                valueField: 'count',
                argumentField: 'found',
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Search/charts/ResultsFoundChart.tsx